import React from "react";
import dayjs from "dayjs";
import { getPaymentMethodCode, PaymentMethod } from "../../Enums";

interface PaymentDetailsProps {
  type: string;
  data: {
    transaction_no?: string;
    deposit_bank_name?: string;
    deposit_account_number?: string;
    cheque_no?: string;
    bank_name?: string;
    cheque_date?: string;
  };
}
export const PaymentMethodDetails: React.FC<PaymentDetailsProps> = ({
  type,
  data,
}) => {
  const code = type?.toLowerCase();

  if (code === getPaymentMethodCode(PaymentMethod.CASH)) {
    return (
      <div className="text-[10px] text-gray-500">
        <span className="font-medium text-gray-400">Ref:</span> Cash transaction
      </div>
    );
  }

  if (
    code === getPaymentMethodCode(PaymentMethod.CARD) &&
    data.transaction_no
  ) {
    return (
      <div className="text-[10px] text-gray-500">
        <span className="font-medium text-gray-400">Tx Ref:</span>{" "}
        {data.transaction_no}
        {data.deposit_bank_name && (
          <div className="mt-0.5">
            <span className="font-medium text-gray-400">Bank:</span>{" "}
            {data.deposit_bank_name}{" "}
            {data.deposit_account_number
              ? `(${data.deposit_account_number})`
              : ""}
          </div>
        )}
      </div>
    );
  }

  if (
    code === getPaymentMethodCode(PaymentMethod.BANK_TRANSFER) &&
    data.transaction_no
  ) {
    return (
      <div className="text-[10px] text-gray-500">
        <span className="font-medium text-gray-400">Ref No:</span>{" "}
        {data.transaction_no}
        {data.deposit_bank_name && (
          <div className="mt-0.5">
            <span className="font-medium text-gray-400">Bank:</span>{" "}
            {data.deposit_bank_name}{" "}
            {data.deposit_account_number
              ? `(${data.deposit_account_number})`
              : ""}
          </div>
        )}
      </div>
    );
  }

  if (code === getPaymentMethodCode(PaymentMethod.CHEQUE)) {
    return (
      <div className="text-[10px] text-gray-500 flex flex-col gap-0.5 mt-0.5 bg-gray-50 p-1.5 rounded border border-gray-100">
        <div>
          <span className="font-medium text-gray-400">Cheque No:</span>{" "}
          {data.cheque_no || "N/A"}
        </div>
        <div>
          <span className="font-medium text-gray-400">Bank Name:</span>{" "}
          {data.bank_name || "N/A"}
        </div>
        <div>
          <span className="font-medium text-gray-400">Cheque Date:</span>{" "}
          {data.cheque_date
            ? dayjs(data.cheque_date).format("YYYY-MM-DD")
            : "N/A"}
        </div>
        {data.deposit_bank_name && (
          <div className="mt-0.5 border-t border-gray-200 pt-0.5">
            <span className="font-medium text-gray-400">Target Bank:</span>{" "}
            {data.deposit_bank_name}{" "}
            {data.deposit_account_number
              ? `(${data.deposit_account_number})`
              : ""}
          </div>
        )}
      </div>
    );
  }

  if (code === getPaymentMethodCode(PaymentMethod.CREDIT)) {
    return (
      <div className="text-[10px] text-gray-500">
        <span className="font-medium text-gray-400">Ref:</span> Customer credit offset
      </div>
    );
  }

  return null;
};
